module.exports = __webpack_public_path__ + "WhyChooseUsImagea-1c451dd8.webp";